import * as React from "react";

import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader } from "baseui/modal";
import { TableBuilder, TableBuilderColumn } from "baseui/table-semantic";

import { BlockProps } from "baseui/block";
import { Link } from "kanopi-components/Link";
import { Row } from "baseui/data-table";
import { StringDisplay } from "./StringDisplay";
import { VerticalSpacer } from "kanopi-components/SpaceWrapper/VerticalSpacer";
import { useUser } from "kw/auth/useUser";

export type TAddressDisplay = {
  answer?: {
    description: string;
  };
} & BlockProps;

export const AddressDisplay: React.FC<TAddressDisplay> = ({ answer, ...restProps }) => {
  const user = useUser();
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <VerticalSpacer gap="inner-section">
      <StringDisplay answer={answer?.description} {...restProps} />
      <ClimateModal
        data={answer?.climateData?.elements}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
      />
    </VerticalSpacer>
  );
};

interface ClimateModalProps {
  data: unknown;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export const ClimateModal = ({ data, isOpen, setIsOpen }: ClimateModalProps) => {
  const humanize = (str) => {
    const frags = str?.split("_");
    for (let i = 0; i < frags.length; i++) {
      frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
    }
    return frags.join(" ");
  };
  return (
    <Modal
      onClose={() => setIsOpen(false)}
      closeable
      isOpen={isOpen}
      animate
      autoFocus
      size="auto"
      overrides={{
        Root: {
          style: {
            zIndex: 9999,
          },
        },
        Dialog: {
          style: {
            maxHeight: "760px",
          },
        },
      }}
    >
      <ModalBody>
        <TableBuilder
          data={data}
          overrides={{
            Root: {
              style: {
                maxHeight: "560px",
                maxWidth: "100%",
              },
            },
          }}
        >
          <TableBuilderColumn header="Product">
            {(row: Row) => humanize(row.Product)}
          </TableBuilderColumn>
          <TableBuilderColumn header="Field">
            {(row: Row) => humanize(row.Field)}
          </TableBuilderColumn>
          <TableBuilderColumn header="Value">
            {(row: Row) => row.Value}
          </TableBuilderColumn>
        </TableBuilder>
      </ModalBody>
      <ModalFooter>
        <ModalButton
          onClick={() => {
            setIsOpen(false);
          }}
        >
          Close
        </ModalButton>
      </ModalFooter>
    </Modal>
  );
};
